/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import components from '../FlexForm/Elements/Components/Components'
import FlexForm from '../FlexForm/FlexForm'

import { Divider, Typography, Button, Paper, TextField, FormControl, OutlinedInput, InputLabel, IconButton, Slider, Collapse, Tooltip  } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Add, Delete, ExpandLess, ExpandMore } from '@material-ui/icons'

import Field from './components/Field'

import { v4 as uuidv4 } from 'uuid';

const clone = require('rfdc')()

const styles = theme => ({
    field : {
        boxSizing: 'border-box', 
        margin : '1%', 
        width : '48%'
    }
})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

let field = {
    name: "",
    elements: null,
    component: null,
    component_params: [],
    value: {
        number: null,
        text: null,
        list: null,
        boolean: null
    }
}

class FlexFormGenerator extends Component {
    state = {
        write_fields: [],
        form_config : {},
    }

    componentDidMount () {
        if (JSON.stringify(this.props.config) !== JSON.stringify(this.state.write_fields)) {
            this.setState({...this.state, write_fields : this.props.config})
        }
    }

    loadAutoDiscoveredFields = () => {
        //TBD after auto discovery
    }

    renderAddField = () => {
        return (
            <Button
                variant = 'contained'
                color = 'primary'
                size = 'small'
                startIcon = {<Add fontSize = 'small'/>}
                onClick = {this.addField}
            >Add Field</Button>
        )
    }

    addField = () => {
        let new_state = clone(this.state)
        let new_field = clone(field)
        new_field.id = uuidv4()
        new_state.write_fields.push(new_field)
        this.setState({...new_state}, () => this.props.updateParent(this.state.write_fields))
    }

    deleteField = (id) => {
        let new_state = clone(this.state)
        let field_index = new_state.write_fields.findIndex(field => field.id === id)
        new_state.write_fields.splice(field_index, 1)
        this.setState({...new_state}, () => this.props.updateParent(this.state.write_fields))
    }

    updateField = (id, key_name, value) => {
        let new_state = clone(this.state)
        let field_for_update = new_state.write_fields.find(field => field.id === id)
        field_for_update[key_name] = value

        if (key_name === 'component') {
            field_for_update.component_params = components.find(comp => comp.type === value).setup_form
        }

        this.setState({...new_state}, () => {
            console.log("Updated Fields State: ", this.state.write_fields)
            this.props.updateParent(this.state.write_fields)
        })
    }

    updateParam = (id, param_name, value, value_key) => {
        console.log("FlexForm Updating : " + param_name + " , with value : " + value + " on key : ", value_key)
        let new_state = clone(this.state)
        let field_for_update = new_state.write_fields.find(field => field.id === id)
        let param_index = field_for_update.component_params.findIndex(param => param.name === param_name)

        if (param_index === -1) {
            let new_param = {
                name : param_name,
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                }
            }

            new_param.value[value_key] = value
            field_for_update.component_params.push(new_param)
        } else {
            field_for_update.component_params[param_index].value[value_key] = value
        }

        this.setState({...new_state}, () => {
            console.log("Updated Fields State: ", this.state.write_fields)
            this.props.updateParent(this.state.write_fields)
        })
    }

    refreshParams = (id, params) => {
        console.log("FFGenerator :: Params to refresh : ", params)
        let new_state = clone(this.state)
        let field_for_update_index = new_state.write_fields.findIndex(field => field.id === id)
        let field_for_update = new_state.write_fields[field_for_update_index]
        let component_type = field_for_update.component
        
        let comp_params = []
        let comp = components.find(comp => comp.type === component_type)

        if (comp) {
            comp_params = comp.component_params
            field_for_update.component_params = params
            let processed_params = params.map(param => {
                let param_name = param.name
                let param_component = param.component
                let param_value_type = comp_params.find(par => par.name === param_name).value_type
                if (param_component === 'group') {
                    let processed_value = param.elements.map(element => {
                        let entries = []
                        element.map(el => {
                            let entry = []
                            entry.push(el.name)
                            entry.push(el.value.text)
                            entries.push(entry)
                        })
                        console.log("FFGenerator :: Value Entries : ", entries)
                        return Object.fromEntries(entries)
                    })
                    console.log("FFGenerator :: Processed Value : ", processed_value)
                    param.value.list = processed_value
                    return param
                } else {
                    return param
                }
            }) 
            // params.map(param => {
            //     let param_name = param.name
            //     let param_component = param.component
            //     let param_value_type = comp_params.find(par => par.name === param_name).value_type
            //     if (param_component === 'group') {
            //         let value_list = param.elements.map(group => {
            //             let val_object = {}
            //             group.map(element => {
            //                 val_object[element.name] = element.value.text
            //             })
            //             return val_object
            //         })
            //         field_for_update.component_params.find(comp_param => comp_param.name === param_name).value[param_value_type] = value_list
            //     } else {
            //         field_for_update.component_params.find(comp_param => comp_param.name === param_name).value[param_value_type] = param.value[param_value_type]
            //     }
            // })
        }

        this.setState({...new_state}, () => {
            console.log("FFGenerator :: Updated Fields State: ", this.state.write_fields)
            this.props.updateParent(this.state.write_fields)
        })
    }

    getComponents = () => {
        let form_components = components.map(component => {
            let comp = {
                type : component.type,
                annotation : component.annotation
            }

            return comp
        })

        return form_components
    }

    renderFields = () => {
        const { classes } = this.props
        let fields = this.state.write_fields.map(field => {
            return (
                <Field 
                    key = {field.id} 
                    field = {field} 
                    components = {this.getComponents()}
                    binding_keys = {this.props.binding_keys}
                    delete = {(id) => this.deleteField(id)}
                    update_field = {(id, key_name, value) => this.updateField(id, key_name, value)}
                    update_param = {(id, param_name, value, value_key) => this.updateParam(id, param_name, value, value_key)}
                    refresh_params = {(id, params) => this.refreshParams(id, params)}
                />
            )
        })

        return fields
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', padding : '5px', maxHeight : '100%', overflow : 'scroll'}}>
                    <Typography variant = 'button'>{this.props.heading}</Typography>
                    <Divider style = {{marginTop: '5px', marginBottom : '5px'}}/>
                    <div style = {{width : '100%', padding : '5px'}}>
                        {this.renderFields()}
                        {this.renderAddField()}
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(FlexFormGenerator);